import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import FundDetailsTabSkeleton from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabSkeleton';
import AlertMessageBase from 'components/Generic/AlertMessageBase';
import { useI18n } from 'next-localization';
import useHelpers from 'hooks/helpers';
import { useFetchKeyRiskTabDataQuery } from '@/store/fundDetails/services/fundDetailsApi';
import usePayload from 'hooks/useFundDetailsRequestPayload';

const FundDetailsKeyRiskTab = () => {
  const { t } = useI18n();
  const { getErrorDictionary } = useHelpers();
  const { shareClass, language, countryCode, correlationFundRangeId, site } = usePayload();
  const { data, error, isLoading } = useFetchKeyRiskTabDataQuery(
    {
      shareClass,
      language,
      countryCode,
      correlationFundRangeId,
      site,
    },
    {
      skip: !shareClass,
    }
  );
  return (
    <FundDetailsTabRow className="mt-4">
      {isLoading ? (
        <FundDetailsTabSkeleton />
      ) : error ? (
        <AlertMessageBase type="error" title={t(getErrorDictionary(error))} />
      ) : data && data.content?.keyRisk.length !== 0 ? (
        data.content.keyRisk.map((item, index) => (
          <p key={item} className={`body-default text-grey ${index > 0 ? 'mt-3' : ''}`}>
            {item}
          </p>
        ))
      ) : (
        <div className="body-default">{t('noResultsMessage')}</div>
      )}
    </FundDetailsTabRow>
  );
};

export default FundDetailsKeyRiskTab;
